import { useCallback, useState } from 'react';
import { useActivePosEntityContext } from 'src/contexts/ActivePosEntityContext';
import { useAppContext } from 'src/contexts/AppContext';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import { useClientLogContext } from 'src/contexts/ClientLogContext';
import { tryInvokeApi } from 'src/utils/tryExecuteUtils';
import { ListingGroup, ListingGroupClient } from 'src/WebApiController';

export const useGroupOperations = (listingGroup: ListingGroup) => {
  const { setActivePosEntity } = useActivePosEntityContext();
  const { activeAccountWebClientConfig } = useAppContext();
  const { showErrorDialog } = useClientLogContext();
  const {
    updateExpandedListItems,
    eventsExpansion: { refreshExpandedListItems },
  } = useCatalogDataContext();
  const [isLoading, setIsLoading] = useState(false);

  const onUngroupListings = useCallback(
    (callback?: () => void) => {
      if (!listingGroup) {
        return;
      }
      tryInvokeApi(
        async () => {
          setIsLoading(true);

          if (listingGroup.ltGrpId) {
            const ungroupedListings = await new ListingGroupClient(
              activeAccountWebClientConfig
            ).ungroupListings(listingGroup.ltGrpId);

            updateExpandedListItems(ungroupedListings);

            setActivePosEntity(0);

            // kick off a background refresh, but not wait since we already force updateExpandedListItems
            refreshExpandedListItems();

            callback?.();
          }
        },
        (error) => {
          showErrorDialog('ListingGroupClient.ungroupListings', error, {
            trackErrorData: listingGroup,
          });
        },
        () => {
          setIsLoading(false);
        }
      );
    },
    [
      activeAccountWebClientConfig,
      listingGroup,
      refreshExpandedListItems,
      setActivePosEntity,
      showErrorDialog,
      updateExpandedListItems,
    ]
  );

  return {
    isLoading,
    onUngroupListings,
  };
};
